import api from '../http-common';

// BASE PRICE

const getPriceCalculatorSettings = () =>
  api.post('/base-prices/get-options-data');

const getPriceCalculatorMonths = (data) =>
  api.post('/base-prices/get-months', data);

const updatePriceCalculatorMonths = (data) =>
  api.post('/base-prices/update-months', data);

// PUBLISHED BASE PRICE

const getPriceCalculatorPublishedMonths = (data) =>
  api.post('/base-prices/get-published-months', data);

const updatePriceCalculatorPublishedMonths = (data) =>
  api.post('/base-prices/update-published-months', data);

// MILK TYPES BASE PRICE

const getMilkTypesPricesOptions = () =>
  api.post('/milk-types/milk-payment/base-prices/get-options-data');

const getMilkTypesMonths = (data) =>
  api.post('/milk-types/milk-payment/base-prices/get-months', data);

const updateMilkTypesMonths = (data) =>
  api.post('/milk-types/milk-payment/base-prices/update-months', data);

// PARTIAL MILK TYPES BASE PRICE

const getPartialPricesOptions = () =>
  api.post('/milk-types/milk-payment/partial-base-prices/get-options-data');

const getPartialMonths = (data) =>
  api.post('/milk-types/milk-payment/partial-base-prices/get-months', data);

const updatePartialMonths = (data) =>
  api.post('/milk-types/milk-payment/partial-base-prices/update-months', data);

export const PriceCalculatorService = {
  getPriceCalculatorSettings,
  getPriceCalculatorMonths,
  updatePriceCalculatorMonths,
  getPriceCalculatorPublishedMonths,
  updatePriceCalculatorPublishedMonths,
  getMilkTypesPricesOptions,
  getMilkTypesMonths,
  updateMilkTypesMonths,
  getPartialPricesOptions,
  getPartialMonths,
  updatePartialMonths
}
